"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalePurposeSubCategory = void 0;
const type_utils_1 = require("@transcend-io/type-utils");
exports.SalePurposeSubCategory = (0, type_utils_1.makeEnum)({
    /** Fallback sub purpose */
    Sale: 'SALE',
});
//# sourceMappingURL=sale.js.map